import * as React from 'react';
import styled from 'styled-components';
import StyledFilterContainer from 'flow-doctor-lib/components/filters/StyledFilterContainer';
import ClassicReenrollmentPropertyFilterRenderer from 'flow-doctor-lib/components/filters/classicReenrollment/ClassicReenrollmentPropertyFilterRenderer';
import ClassicReenrollmentFormSubmissionFilterRenderer from 'flow-doctor-lib/components/filters/classicReenrollment/ClassicReenrollmentFormSubmissionFilterRenderer';
import ClassicReenrollmentListFilterRenderer from 'flow-doctor-lib/components/filters/classicReenrollment/ClassicReenrollmentListFilterRenderer';
import ClassicReenrollmentPageViewFilterRenderer from 'flow-doctor-lib/components/filters/classicReenrollment/ClassicReenrollmentPageViewFilterRenderer';
import ClassicReenrollmentLegacyEventFilterRenderer from 'flow-doctor-lib/components/filters/classicReenrollment/ClassicReenrollmentLegacyEventFilterRenderer';
import ClassicReenrollmentIntegrationsEventFilterRenderer from 'flow-doctor-lib/components/filters/classicReenrollment/ClassicReenrollmentIntegrationsEventFilterRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
// Integrations filters have nested filterLines that render nested filters, so we need to adjust some of the styling for better UX
const IntegrationsFilterRenderContainer = styled(StyledFilterContainer).withConfig({
  displayName: "ClassicReenrollmentFilterRenderer__IntegrationsFilterRenderContainer",
  componentId: "sc-26qzeq-0"
})(["inline-size:initial !important;div{border:none !important;padding:0 !important;inline-size:initial !important;}"]);
const ClassicReenrollmentFilterRenderer = ({
  reEnrollmentTriggerSet,
  objectTypeId,
  portalId,
  condensed
}) => {
  const firstTriggerType = reEnrollmentTriggerSet[0].type;
  const triggerLabel = (() => {
    switch (firstTriggerType) {
      case 'CONTACT_PROPERTY_NAME':
        return /*#__PURE__*/_jsx(ClassicReenrollmentPropertyFilterRenderer, {
          reEnrollmentTriggerSet: reEnrollmentTriggerSet,
          objectTypeId: objectTypeId
        });
      case 'FORM':
        return /*#__PURE__*/_jsx(ClassicReenrollmentFormSubmissionFilterRenderer, {
          reEnrollmentTriggerSet: reEnrollmentTriggerSet
        });
      case 'DYNAMIC_LIST':
        return /*#__PURE__*/_jsx(ClassicReenrollmentListFilterRenderer, {
          portalId: portalId,
          reEnrollmentTriggerSet: reEnrollmentTriggerSet
        });
      case 'PAGE_VIEW':
        return /*#__PURE__*/_jsx(ClassicReenrollmentPageViewFilterRenderer, {
          reEnrollmentTriggerSet: reEnrollmentTriggerSet
        });
      case 'EVENT':
        return /*#__PURE__*/_jsx(ClassicReenrollmentLegacyEventFilterRenderer, {
          reEnrollmentTriggerSet: reEnrollmentTriggerSet
        });
      case 'INTEGRATIONS_TIMELINE_EVENT':
        return /*#__PURE__*/_jsx(ClassicReenrollmentIntegrationsEventFilterRenderer, {
          portalId: portalId,
          objectTypeId: objectTypeId,
          condensed: !!condensed,
          reEnrollmentTriggerSet: reEnrollmentTriggerSet
        });
      default:
        return null;
    }
  })();
  const ContainerComponent = firstTriggerType === 'INTEGRATIONS_TIMELINE_EVENT' ? IntegrationsFilterRenderContainer : StyledFilterContainer;
  return /*#__PURE__*/_jsx(ContainerComponent, {
    filterWidthType: condensed ? 'LIST_FIXED' : 'LIST_STRETCHED',
    children: triggerLabel
  });
};
export default ClassicReenrollmentFilterRenderer;